import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-form',
  templateUrl: './app-sidebar-form.component.html'
})
export class AppSidebarFormComponent { }



// WEBPACK FOOTER //
// /opt/sss_web/sss_web/src/app/components/app-sidebar-form/app-sidebar-form.component.ts